export function CoreNgEnterDirective (
  KEYCODES: any
) : ng.IDirectiveLinkFn {
  return function link ( scope : ng.IScope, element : ng.IRootElementService, attrs : ng.IAttributes ) : void {
    function handleKeyPress ( event : JQuery.Event ) {
      if ( event.keyCode === KEYCODES.enter ) {
        scope.$apply(() => {
          scope.$eval(attrs.ngEnter);
        });

        event.preventDefault();
      }
    }

    element.on('keydown keypress', handleKeyPress);

    scope.$on('$destroy', () => {
      element.off('keydown keypress', handleKeyPress);
    });
  };
}